<template>
    <v-dialog v-model="load" :max-width="tamModal" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="objModal.titulo"></span>
            </v-card-title>

            <v-card-text>
                <v-container fluid grid-list-sm>
                    <!-- Fuente de Ingreso Dependiente -->
                    <v-row dense v-if="parametro.idTipoFuenteIngresoDependiente == parseInt(objModal.idTipoFuenteIngreso)">
                        <v-col cols="12" sm="12">
                            <v-form ref="form_fuente_ingreso_dependiente" :lazy-validation="false">

                                <v-row dense v-if="objModal.mostrar">
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Fuente Ingreso *" color="textbox"
                                            v-model="objModal.idFuenteIngreso" :items="listGeneral.listaFuenteIngreso"
                                            item-value="idFuenteIngreso" item-text="fuenteIngreso" autocomplete
                                            :rules="requeridoRegla" @change="onTipoFuente" outlined dense />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="Especificación *" color="textbox" v-model="objModal.otros"
                                            :rules="objModal.mostrar ? _.concat(requeridoRegla,soloLetrasRegla(5,objModal.otros,500)) : []"
                                            outlined dense />
                                    </v-col>
                                </v-row>

                                <v-row dense v-else>

                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Fuente Ingreso *" color="textbox"
                                            v-model="objModal.idFuenteIngreso" :items="listGeneral.listaFuenteIngreso"
                                            item-value="idFuenteIngreso" item-text="fuenteIngreso" autocomplete
                                            :rules="requeridoRegla" @change="onTipoFuente" outlined dense />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field label="Nombre de Empresa *" color="textbox"
                                            v-model="objModal.nomEmpresa"
                                            :rules="!objModal.mostrar ? _.concat(requeridoRegla,soloLetrasRegla(5,objModal.nomEmpresa,500)) : []"
                                            outlined dense />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field label="Cargo *" color="textbox" v-model="objModal.cargo"
                                            :rules="!objModal.mostrar ? _.concat(requeridoRegla,soloLetrasRegla(5,objModal.cargo,300)) : []"
                                            outlined dense />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-dialog ref="dialogFueIng" v-model="objDate.abrirDialogo"
                                            :return-value.sync="objModal.fechaIngreso" persistent width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field color="textbox" v-model="objModal.fechaIngreso"
                                                    label="Fecha de Ingreso *"
                                                    :rules="!objModal.mostrar ? requeridoRegla : []"
                                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                                            </template>
                                            <v-date-picker v-model="objModal.fechaIngreso" color="primary" scrollable
                                                locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn text rounded color="secundary" @click="objDate.abrirDialogo = false"
                                                    v-html="'Salir'">
                                                </v-btn>
                                                <v-btn text color="primary" rounded
                                                    @click="$refs.dialogFueIng.save(objModal.fechaIngreso)"
                                                    v-html="'Guardar Fecha'"></v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field label="Dirección *" color="textbox" v-model="objModal.direccion"
                                            :rules="!objModal.mostrar ? _.concat(requeridoRegla,max300Regla) : []" outlined
                                            dense />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Provincia *" color="textbox" v-model="objModal.idProvincia"
                                            :items="listGeneral.listaProvincia"
                                            :rules="parseInt(objModal.idFuenteIngreso) != _.toNumber(parametro.idFuenteIngresoDependienteOtros) ? requeridoRegla : []"
                                            @change="onListarCantones('listaCantonFueIng'); objModal.idCanton = null"
                                            outlined dense />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-autocomplete label="Cantón *" color="textbox" v-model="objModal.idCanton"
                                            :items="listGeneral.listaCantonFueIng" item-value="idCanton" item-text="canton"
                                            :rules="_.toNumber(objModal.idFuenteIngreso) != _.toNumber(parametro.idFuenteIngresoDependienteOtros) ? requeridoRegla : []"
                                            outlined dense />
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="12" class="text-right mt-2 mb-2">
                                        <v-btn outlined rounded color="danger" class="mr-1" @click="close('form_fuente_ingreso_dependiente');">Cancelar</v-btn>
                                        <v-btn rounded dark color="primary" @click="validarModal('form_fuente_ingreso_dependiente','detalleFuenteIngresoDep')"> Guardar </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                    <!-- Fin Fuente de Ingreso Dependiente -->

                    <!-- Fuente de Ingreso Independiente -->
                    <v-row dense  v-else-if="parametro.idTipoFuenteIngresoIndependiente == parseInt(objModal.idTipoFuenteIngreso)">
                        <v-form ref="form_fuente_ingreso_independiente">
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Fuente Ingreso *" color="textbox" v-model="objModal.idFuenteIngreso"
                                    :items="listGeneral.listaFuenteIngreso" item-value="idFuenteIngreso"
                                    item-text="fuenteIngreso" autocomplete :rules="requeridoRegla" @change="onTipoFuente"
                                    outlined dense> </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" v-show="objModal.mostrarOtrosFuentes">
                                <v-text-field label="Especificación *" color="textbox" v-model="objModal.otros"
                                    :rules="objModal.mostrarOtrosFuentes ? _.concat(requeridoRegla,soloLetrasRegla(5,objModal.otros,500)) : []"
                                    outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="close('form_fuente_ingreso_independiente');"> Cancelar </v-btn>
                                <v-btn rounded dark color="primary" @click="validarModal('form_fuente_ingreso_independiente','detalleFuenteIngresoInd')">Guardar</v-btn>
                            </v-col>
                        </v-form>
                    </v-row>
                    <!-- Fin Fuente de Ingreso Independiente -->
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalDatoActividadEconomicaComponent',
        props:{
            objFuenteIngresoModal:{ type:Object, default:{} },
            objFuenteIngreso:{ type:Object, default:{} },
            parametro:{ type:Object, default:{} },
            listGeneral:{ type:Object, default:{} },
            load:{ type:Boolean, default:false }
        },
        inject:['resetModal','setData'],
        data() {
            return {
                objDate: {
                    abrirDialogo: false
                },
                objModal: {}
            }
        },
        watch:{
            load(val){
                if(val){
                    this.$set(this,'objModal',this.objFuenteIngresoModal);
                    if(this.objModal.new)
                        this.onNuevo();
                    else
                        this.onEditar(this.objModal,null);
                }
            }
        },
        methods: {
            onListarCantones(lista) {
                var error = 'E';

                var objeto = {
                    opcion: 'L',
                    idProvincia: this.objModal.idProvincia,
                    idEstado: this.objModal.idEstado
                };

                return axios.post(`${BASE_URI}administrador/canton/listar`, objeto)
                            .then((r) => {
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    this.$set(this.listGeneral, lista, r.data.data);
                                return r;
                            }).catch((e) => {
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onTipoFuente() {
                if (this.parametro.idTipoFuenteIngresoIndependiente == _.toNumber(this.objModal.idTipoFuenteIngreso))
                    this.objModal.mostrarOtrosFuentes = this.objModal.idFuenteIngreso == this.parametro.idFuenteIngresoIndependienteOtros ? true : false;
                else
                if (this.parametro.idTipoFuenteIngresoDependiente == _.toNumber(this.objModal.idTipoFuenteIngreso)) {
                    this.objModal.mostrar = parseInt(this.objModal.idFuenteIngreso) == parseInt(this.parametro.idFuenteIngresoDependienteOtros) ? true : false;
                }
            },
            onNuevo() {
                var error = 'E';

                this.objModal = {
                    titulo: 'Nueva Fuente de Ingreso',
                    idTipoFuenteIngreso: _.get(this.objFuenteIngreso,'idTipoFuenteIngreso', null),
                    idEstado: this.parametro.idEstadoDefault
                };

                var objeto = {
                    opcion: 'L_FUENTE_INGRESO',
                    idTipoFuenteIngreso: this.objModal.idTipoFuenteIngreso,
                    idEstado: this.parametro.idEstadoDefault
                };

                axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`, objeto)
                     .then((r) => {
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                            this.$set(this.listGeneral, 'listaFuenteIngreso', r.data.data);
                            this.onTipoFuente();
                    }).catch((e) => {
                        mensajesAlerta(e, error);
                    });

            },
            onEditar(objeto, index) {
                var error = 'E';
                this.objModal = _.merge({}, { titulo: 'Editar Fuente de Ingreso', idTipoFuenteIngreso: _.get(this.objFuenteIngreso,'idTipoFuenteIngreso', null) },objeto);
                this.objModal.mostrar = parseInt(this.objModal.idFuenteIngreso) == parseInt(this.parametro.idFuenteIngresoDependienteOtros) ? true : false;
                
                var obj = { opcion: 'L_FUENTE_INGRESO', idTipoFuenteIngreso: this.objModal.idTipoFuenteIngreso, idEstado: this.parametro.idEstadoDefault };

                switch (parseInt(this.objModal.idTipoFuenteIngreso)) {
                    case this.parametro.idTipoFuenteIngresoIndependiente:
                    case this.parametro.idTipoFuenteIngresoDependiente:

                        axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`, obj)
                             .then((r) => {
                                 if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                 if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                     this.$set(this.listGeneral, 'listaFuenteIngreso', r.data.data);
                                     this.onTipoFuente();                                
 
                                 return r;
                             })
                             .then((r) => {
                                 if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                 if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    return this.onListarCantones('listaCantonFueIng');
                                //  this.$parent.$parent.$parent.$parent.objFuenteIngresoModal.abrirModal = true;
                             })
                             .catch((e) => {
                                 mensajesAlerta(e,error);
                            });
                        break;
                }
            },
            validarModal(form, lista) {
                try {
                    if (!this.$refs[form].validate()) throw mensajeEstandar.corregirInformacion;

                    var fuente = _.find(this.listGeneral.listaFuenteIngreso, (o) => { return o.idFuenteIngreso == this.objModal.idFuenteIngreso });
                    var objeto = {};

                    this.objModal.fuente = fuente.fuenteIngreso;
                    // Fuente Independiente
                    if (this.parametro.idTipoFuenteIngresoIndependiente == _.toNumber(this.objModal.idTipoFuenteIngreso)) {
                        if (_.toNumber(this.objModal.idFuenteIngreso) == _.toNumber(this.parametro.idFuenteIngresoIndependienteOtros)){
                            var keys = ['id', 'index', 'idFormulario','idFuenteIngreso', 'fuente', 'otros', 'idEstado'];
                            objeto = _.pick(this.objModal,keys);
                        }
                        else{
                            var keys = ['id', 'index', 'idFormulario','idFuenteIngreso', 'fuente', 'idEstado'];
                            objeto = _.pick(this.objModal,keys);
                        }
                    }
                    // Fuente Dependiente
                    else {
                        if (this.parametro.idTipoFuenteIngresoDependiente == _.toNumber(this.objModal.idTipoFuenteIngreso)) {
                            if (_.toNumber(this.objModal.idFuenteIngreso) == _.toNumber(this.parametro.idFuenteIngresoDependienteOtros)){
                                var keys = ['id', 'index', 'idFormulario','idFuenteIngreso', 'fuente','otros', 'idEstado'];
                                objeto = _.pick(this.objModal,keys);
                            }
                            else{
                                var keys = [
                                            'id', 'index', 'idFormulario', 'idFuenteIngreso', 'fuente', 'idCanton',
                                            'nomEmpresa', 'fechaIngreso', 'cargo', 'direccion','idProvincia','idEstado'
                                ];
                                objeto = _.pick(this.objModal,keys);
                            }
                        }
                    }
                
                    var l = _.clone(_.get(this.listGeneral, lista,[]));

                    if (_.isUndefined(_.find(l, (o) => { return _.toNumber(o.id) == _.toNumber(objeto.id) }))) {
                        l.push(_.merge({}, objeto, { 'id': _.uniqueId() }));
                    } else {
                        var pos = _.findIndex(l, (o) => {
                            return _.toNumber(o.id) == _.toNumber(objeto.id);
                        });
                        l[pos] = objeto;
                    }
                    var paretStepperVeh = this.$parent.$parent.$parent.$parent;
                    this.setData(lista,l);
                    // this.$set(paretStepperVeh, ['listGeneral',lista], []);
                    // this.$set(paretStepperVeh, ['listGeneral',lista], l);
                    this.close(form);
                } catch (e) {
                    mensajesAlerta(e, 'I');
                }
            },
            close(form) {
                this.$refs[form].resetValidation();
                this.onTipoFuente();
                this.$set(this, 'objModal', {
                    titulo: 'Nueva Fuente de Ingreso',
                    mostrarOtrosFuentes: false,
                    mostrar: false,
                    fechaIngreso: moment().format('YYYY-MM-DD')
                });
                this.resetModal();
            }
        }
    }
</script>